module.exports = __webpack_public_path__ + "img/20200512_163255.5fb03c55.jpg";